import Vue from 'vue';
import Vuetify from 'vuetify/lib';

Vue.use(Vuetify);

export default new Vuetify
({
    theme: {
        themes: {
            light: {
                primary: '#44546D',
                secondary: '#49677C',
                toolbarPrimary: '#CFD8DC',
                toolbarSecondary: '#ECEFF1',
                alwaysWhite: '#FFFFFF',
                lightAccent: '#B9B6BE',
               
                brightTitle: '#c9e6fb',
                
                iconTextColor: '#446799',
                
                brighterBackground: '#f5f5f5',
                brightBackground: '#ECEFF1',
                boxOnBrightBackground: '#cbd4da',
                brightText: '#FBFAFC',
                
                accent: '#E1A233',
                
            }
        }
    }
});
